const searchBtn = document.querySelector("#search-button");
const searchCloseBtn = document.querySelector("#search-close");
const searchDialog = document.querySelector("#search-dialog");
const searchInput = document.querySelector("#search-input");
const popularItems = document.querySelectorAll(".popular-item");
let recentItems = document.querySelectorAll(".recent-item");
const clearRecentBtn = document.querySelector("#clear-recent");
const recentsContainer = document.querySelector("#recents-container");
const searchInfoContainer = document.querySelector("#search-info");
const searchResultsContainer = document.querySelector("#search-results");
const resetSearchBtn = document.querySelector("#reset-search");
const searchKey  = document.querySelector("#search-key");

const debounce = (func, timeout = 300) => {
    let timer;
    return (...args) => {
        clearTimeout(timer);
        timer = setTimeout(() => {
            func.apply(this, args);
        }, timeout);
    };
}

const showSearchResults = () => {
    searchInfoContainer.classList.remove("show");
    searchResultsContainer.classList.add("show");
}

const showSearchInfo = () => {
    searchInfoContainer.classList.add("show");
    searchResultsContainer.classList.remove("show");
}

const search = (input, data) => {
    return data.split(' ').join('').toLowerCase().includes(input.split(' ').join('').toLowerCase());
}
const searchEvent = () => {
    const searchVal = searchInput.value;
    
    searchKey.innerHTML = searchVal.toLowerCase();

    searchVal.length > 0 ? showSearchResults() : showSearchInfo();
    
    const resultItems = searchResultsContainer.querySelectorAll(".result-item");
    resultItems.forEach(item => {
        const resultData = item.dataset.value;
        if (search(searchVal, resultData)) {
            item.classList.add("show");
        } else {
            item.classList.remove("show");
        }
    })
}

const debouncedSearch = debounce(searchEvent, 300);

const STORAGE_KEY = "nexacu-recent-search";

const getRecentSearches = () => {
    return JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
};

const renderRecentSearches = () => {
    const searches = getRecentSearches();

    if (searches.length > 0) {
        recentsContainer.classList.add("show");
        const list = document.querySelector(".recent-items");
        list.innerHTML = "";

        searches.forEach(item => {
            list.innerHTML += `
                <li>
                    <button type="button" class="btn recent-item" data-value="${item}">
                        <i class="far fa-clock"></i>
                        <span>${item}</span>
                    </button>
                </li>
            `;
        });
    } else {
        recentsContainer.classList.remove("show");
    }

    recentItems = document.querySelectorAll(".recent-item");

};

const saveRecentSearch = (value, limit = 5) => {
    let searches = getRecentSearches();

    searches = searches.filter(
        item => item.toLowerCase() !== value.toLowerCase()
    );

    searches.unshift(value);

    searches = searches.slice(0, limit);

    localStorage.setItem(STORAGE_KEY, JSON.stringify(searches));

    renderRecentSearches();
};

const clearRecentSearches = () => {
    localStorage.removeItem(STORAGE_KEY);
    renderRecentSearches();
};

window.addEventListener("load", () => {

    searchBtn.addEventListener("click", function () {
        searchDialog.classList.add("show");
        searchInput.focus();
    });

    renderRecentSearches();

    searchCloseBtn.addEventListener("click", function () {
        searchDialog.classList.remove("show");
    });

    popularItems.forEach((item) => {
        item.addEventListener("click", function (e) {
            e.preventDefault();
            searchInput.value = item.dataset.value;
            searchEvent();
            saveRecentSearch(searchInput.value);
        })
    });

    recentItems.forEach((item) => {
        item.addEventListener("click", function (e) {
            e.preventDefault();
            searchInput.value = item.dataset.value;
            searchEvent();
        })
    })

    searchInput.addEventListener("input",
        debouncedSearch
    );

    searchInput.addEventListener("keydown", function (e) {
        if (e.key === "Enter") {
            saveRecentSearch(searchInput.value);
        }
    });

    clearRecentBtn.addEventListener("click", function () {
        clearRecentSearches();
    });

    resetSearchBtn.addEventListener("click", function () {
        showSearchInfo();
    })

});